// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "breadcrumbs-3LCLw";
var _3 = "breadcrumb-2JaZF";
var _4 = "label__wrapper-ju7X0";
var _5 = "withPath-1Flpg";
var _6 = "separator-3DGrx";
var _7 = "label-3g5kC";
var _8 = "link-1nih2";
var _9 = "icon-1q6qA";
var _a = "selected-3lDlL";
var _b = "disabled-1eQfQ";
export { _1 as "__esModule", _2 as "breadcrumbs", _3 as "breadcrumb", _4 as "label__wrapper", _5 as "withPath", _6 as "separator", _7 as "label", _8 as "link", _9 as "icon", _a as "selected", _b as "disabled" }
export default { "__esModule": _1, "breadcrumbs": _2, "breadcrumb": _3, "label__wrapper": _4, "withPath": _5, "separator": _6, "label": _7, "link": _8, "icon": _9, "selected": _a, "disabled": _b }
